import React, { useContext, useState } from 'react'
import { ContextoGlobal, ContextoGlobalInterface } from '../../../GlobalStates/ContextoGlobal';

import { useNavigate } from 'react-router-dom';

import BackEndAPI from '../../../Services/BackEndAPI';
import { MensagemTipo } from '../../../GlobalStates/MensagemState';

import { Box, Button, Container, Grid, IconButton, Paper, Tab, Tabs, Typography } from '@mui/material'

import CloseIcon from '@mui/icons-material/Close'
import CheckIcon from '@mui/icons-material/Check'
import TextArea from '../../../DevComponents/TextArea';
import ComboBox from '../../../DevComponents/ComboBox';
import { TipoERPInterface, TipoERPType, TipoERPTypes } from '../../../ImportBackend/types/ConstantesDataTypes';
import { RespostaPadraoInterface } from '../../../ImportBackend/Interfaces/PadraoInterfaces';
import { DrgSQLInterface } from '../../../ImportBackend/Interfaces/DrgInterfaces';
import { clsUtils } from 'zlib-utils';
import Condicional from '../../../Layout/Condicional';

export default function DRGCadastroSQL() {

  const contexto = useContext(ContextoGlobal) as ContextoGlobalInterface
  const { mensagemState, setMensagemState } = contexto

  const navigate = useNavigate()

  const ResetDados: DrgSQLInterface = {
    tipoERP: TipoERPType.SEM_ACESSO,
    sqlAdmissao: '',
    sqlAlta: '',
  }

  const [dados, setDados] = useState<DrgSQLInterface>({ ...ResetDados })
  const [conteudoOriginal, setConteudoOriginal] = useState<DrgSQLInterface>({ ...ResetDados })

  const clsApi: BackEndAPI = new BackEndAPI()

  const onChangeTipoERP = (rs: TipoERPInterface) => {

    if (rs && rs.idTipoERP.length > 0 && rs.idTipoERP !== TipoERPType.SEM_ACESSO) {

      const query = `
        getDrgSql (tipoERP: "${rs.idTipoERP}") {
          idDrgSQL
          tipoERP
          sqlAdmissao
          sqlAlta
        }
      `

      clsApi.query<DrgSQLInterface>(query, 'getDrgSql', 'Consultando SQL...', contexto).then(rsSQL => {

        setDados(rsSQL)
        setConteudoOriginal(rsSQL)

      }).catch(() => {

        setMensagemState({
          ...mensagemState,
          titulo: 'Erro! Consulte Suporte!',
          exibir: true,
          mensagem: 'Erro ao consultar SQL do DRG!',
          tipo: MensagemTipo.Error,
          exibirBotao: true
        })

      })


    } else {
      setDados({ ...ResetDados })
    }

  }

  const onGravarSQL = () => {

    if (dados && dados.tipoERP.length > 0) {

      const mutation = `
        updateDrgSql (dados: ${clsUtils.ConverterEmGql(dados)}) {
          ok
          mensagem
        }
      `

      // console.log(mutation)

      clsApi.mutation<RespostaPadraoInterface>(mutation, 'updateDrgSql', 'Atualizando SQL...', contexto).then(rsSQL => {

        if (!rsSQL.ok) {
          setMensagemState({
            ...mensagemState,
            titulo: 'Erro ao atualizar SQL do DRG!',
            exibir: true,
            mensagem: rsSQL.mensagem,
            tipo: MensagemTipo.Error,
            exibirBotao: true
          })

        } else {
          setConteudoOriginal(dados)
        }


      }).catch(() => {

        setMensagemState({
          ...mensagemState,
          titulo: 'Erro! Consulte Suporte!',
          exibir: true,
          mensagem: 'Erro ao atualizar SQL do DRG!',
          tipo: MensagemTipo.Error,
          exibirBotao: true
        })

      })

    }

  }

  const [rsTab, setRsTab] = useState(0)

  const changeRsTab = (_event: React.SyntheticEvent, newValue: number) => {
    setRsTab(newValue)
  }

  return (

    <>

      <Container maxWidth="md" sx={{ mt: 5 }}>

        <Paper variant="outlined" sx={{ padding: 2 }}>

          <Grid container sx={{ display: 'flex', alignItems: 'stretch' }}>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>

              <Typography component="h5" variant="h5" align="left">
                Cadastro SQL DRG
                <Typography variant="body2" gutterBottom>
                  Cadastro do SQL para geração do DRG por tipo de ERP
                </Typography>
              </Typography>

              <IconButton onClick={() => navigate('/')}>
                <CloseIcon />
              </IconButton>

            </Grid>

            <Grid item xs={12}>

              <ComboBox
                campoID='idTipoERP'
                campoDescricao='descricao'
                opcoes={TipoERPTypes}
                dados={dados}
                field='tipoERP'
                setState={setDados}
                label='Sistema ERP'
                onChange={(rs: TipoERPInterface) => onChangeTipoERP(rs)}
              />


            </Grid>

            <Grid item xs={12}>

              <Box sx={{ width: '100%' }}>

                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <Tabs value={rsTab} onChange={changeRsTab} aria-label="drg envio tabs">
                    <Tab label="Admissão" />
                    <Tab label="Alta" />
                  </Tabs>
                </Box>

                <Condicional condicao={rsTab === 0}>

                  <TextArea
                    dados={dados}
                    field='sqlAdmissao'
                    label='SQL Admissão'
                    setState={setDados}
                    height='300px'
                    disabled={dados && dados.tipoERP && dados.tipoERP !== TipoERPType.SEM_ACESSO ? false : true}
                  />
                </Condicional>

                <Condicional condicao={rsTab === 1}>
                  <TextArea
                    dados={dados}
                    field='sqlAlta'
                    label='SQL Alta'
                    setState={setDados}
                    height='300px'
                    disabled={dados && dados.tipoERP && dados.tipoERP !== TipoERPType.SEM_ACESSO ? false : true}
                  />
                </Condicional>
              </Box>

            </Grid>

            <Grid item xs={12} sx={{ mt: 1, textAlign: 'right' }} >
              <Button disabled={dados && dados.tipoERP && dados.tipoERP !== TipoERPType.SEM_ACESSO && JSON.stringify(dados) !== JSON.stringify(conteudoOriginal) ? false : true} variant='contained' startIcon={<CheckIcon />} sx={{ my: 1, py: 1, mr: 2 }} onClick={() => onGravarSQL()}>Gravar</Button>
            </Grid>

          </Grid>
        </Paper>
      </Container>

    </>

  )
}